var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleCheckedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B4FB979E-D335-4856-8E32-013CA7758FAA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 25,
    height: 25,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 25,
    height: 25,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "#1492AF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-418.000000, -836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-47",
    transform: "translate(418.000000, 836.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14,5 C9.032,5 5,9.032 5,14 C5,18.968 9.032,23 14,23 C18.968,23 23,18.968 23,14 C23,9.032 18.968,5 14,5 Z",
    id: "Path",
    fill: "#50566E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/check",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 20 2 20 20 2 20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.3726765,13.2264414 L7.50138517,10.8864811 C7.18422699,10.5143141 6.68002681,10.5143141 6.36286863,10.8864811 C6.04571046,11.2586481 6.04571046,11.8502982 6.36286863,12.2224652 L8.79528597,15.2208748 C9.11244415,15.5930417 9.62477659,15.5930417 9.94193476,15.2208748 L15.6371314,8.11510934 C15.9542895,7.74294235 15.9542895,7.15129225 15.6371314,6.77912525 C15.3199732,6.40695825 14.815773,6.40695825 14.4986148,6.77912525 L9.3726765,13.2264414 Z",
    id: "Icon-Color",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleCheckedIcon);
export default __webpack_public_path__ + "static/media/toggleCheckedIcon.05720fbf5208aac90726eb5ecf508464.svg";
export { ForwardRef as ReactComponent };